(() => {
  if (customElements.get('gi-hero-slideshow')) return;
  customElements.define('gi-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.button = this.parentElement.querySelector('[data-motion-toggle]');
      this.index = 0; this.elapsed = 0; this.animations = new Map();
      this.paused = this.motion.matches;
      this.sync = () => {
        const stopped = this.paused || document.hidden || this.motion.matches;
        this.animations.forEach(a => { if (a.playState !== 'finished') stopped ? a.pause() : a.play(); });
        if (this.button) this.button.textContent = this.paused ? 'Lancer l’animation' : 'Pause';
      };
      this.toggle = () => { this.paused = !this.paused; this.sync(); };
      this.onMotion = () => { this.paused = this.motion.matches; this.sync(); };
      this.button?.addEventListener('click', this.toggle);
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.sync);
      this.last = performance.now();
      this.sync();
      Promise.all(this.slides.map(async img => {
        if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.src = img.dataset.src; }
        try { await img.decode(); return true; } catch (_) { return false; }
      })).then(loaded => {
        if (!this.isConnected) return;
        this.slides = this.slides.filter((_,i) => loaded[i]);
        if (!this.slides.length) return;
        this.slides[0].classList.add('is-active');
        this.zoom(this.slides[0]);
        this.frame = requestAnimationFrame(now => this.tick(now));
      });
    }
    zoom(img) {
      this.animations.get(img)?.cancel();
      const a = img.animate([{transform:'scale(1.025) translateX(0)'},{transform:'scale(1.065) translateX(-.5%)'}], {duration:5200, fill:'forwards', easing:'linear'});
      this.animations.set(img,a); this.sync();
    }
    tick(now) {
      const delta = Math.min(now-this.last,100); this.last=now;
      if (!this.paused && !document.hidden && !this.motion.matches && this.slides.length>1) {
        this.elapsed+=delta;
        if (this.elapsed>=4000) {
          this.elapsed-=4000;
          const previous=this.slides[this.index];
          this.index=(this.index+1)%this.slides.length;
          const next=this.slides[this.index];
          this.slides.forEach(s=>s.style.zIndex=s===next?'2':'1');
          previous.classList.remove('is-active');
          next.classList.add('is-active'); this.zoom(next);
        }
      }
      this.frame=requestAnimationFrame(t=>this.tick(t));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.animations?.forEach(a=>a.cancel());
      this.button?.removeEventListener('click',this.toggle);
      this.motion?.removeEventListener('change',this.onMotion);
      document.removeEventListener('visibilitychange',this.sync);
    }
  });
})();
